import _ from 'lodash'

export const isArrayPopulated = (array: any[]) => _.size(array) > 0
